/*
  운영사(민트블루) 전용 콘솔 노출 여부.

  여기 들어가는 기능은 «우리가 고객사를 관리하는» 화면이다 — 구독·만료·한도 같은 것.
  고객사 서버(예: 삼우 납품본)에는 이 메뉴가 통째로 들어가면 안 된다.
  고객이 자기 만료일을 보거나 바꿀 수 있으면 안 되고, 남의 회사 이름이 목록에 뜨면 더 큰 사고다.

  끄는 법 — 납품용 빌드에서만 끈다
      REACT_APP_OWNER_CONSOLE=false  npm run build

  기본값은 켜짐(우리 서버). 값이 정확히 "false" 일 때만 꺼진다.

  주의: 화면을 숨기는 것만으로는 보안이 되지 않는다.
        서버(routes/subscriptionRoutes.js)에서도 SUPER_ADMIN 만 통과시킨다. 둘 다 있어야 한다.
*/
export const OWNER_CONSOLE_ENABLED =
  String(process.env.REACT_APP_OWNER_CONSOLE || "").toLowerCase() !== "false";

export function canSeeOwnerConsole(me) {
  if (!OWNER_CONSOLE_ENABLED) return false;
  const role = String((me && (me.roleCode || me.role)) || "").toUpperCase();
  return role === "SUPER_ADMIN";
}
